import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["product"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ButtonLink } from "@/components/Buttons/index";
import routes from "@/lib/routes";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export default function PurchaseButtonLink(_ref) {
  let {
      product
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    0: text,
    1: color
  } = useMemo(() => {
    if (product.purchaseAllowed) {
      return ["購入する", {
        fillColor: true
      }];
    } else {
      return ["販売期間外", {
        fillGray: true
      }];
    }
  }, [product]);
  return /*#__PURE__*/_jsx(ButtonLink, _objectSpread(_objectSpread(_objectSpread({
    href: routes.tvodPaymentStep(product.id, 1),
    fontFixed: true,
    disabled: !product.purchaseAllowed
  }, color), props), {}, {
    children: text
  }));
}